module.exports = __webpack_public_path__ + "img/tf.b8b00a26.jpg";